<svg-icon
  class="max-h-4 max-w-4"
  [ngClass]="iconColor()"
  [key]="iconType() === 'patient-alert' ? 'px-16-patient-alert' : 'px-16-cross'"
  [libUiTooltip]="iconType() !== 'patient-alert' ? criticalStatusTooltip : undefined"
  [tooltipPosition]="'bottom'"
></svg-icon>
<ng-template #criticalStatusTooltip>
  <div class="px-3 py-2">
    <div class="typo-h7-light">{{ tooltipText() | translate }}</div>
  </div>
</ng-template>
